import { render, staticRenderFns } from "./Selfpr.vue?vue&type=template&id=248e0712&scoped=true&"
import script from "./Selfpr.vue?vue&type=script&lang=js&"
export * from "./Selfpr.vue?vue&type=script&lang=js&"
import style0 from "./Selfpr.vue?vue&type=style&index=0&id=248e0712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e0712",
  null
  
)

export default component.exports